export const Company = {
  BankAccount: '기업 027-147631-01-015 ㈜우리동네히어로',
};
